import type { Question } from "@quizzes/_schema";

/**
 * True when a question opts into per-session option randomization. Only
 * single/multi questions carry the flag; every other type is always false.
 * Read-only: the admin uses this to display a badge, never to set the flag.
 */
export function isRandomizedQuestion(q: Question): boolean {
  return (q.type === "single" || q.type === "multi") && q.randomizeOptions === true;
}

/**
 * The human title of a screen, for a table row or a report cell.
 *
 * Probed with `in` rather than switched on `type` deliberately: the eight
 * answerable types carry `prompt` and the four pass-through ones carry
 * `heading`, and a version of this that named only `info` printed the literal
 * "undefined" for a `summary`, `signal-summary` or `editorial` screen. Falling
 * through to the id keeps a new screen type legible before anyone updates this.
 */
export function questionLabel(q: Question): string {
  if ("prompt" in q && q.prompt) return q.prompt;
  if ("heading" in q && q.heading) return q.heading;
  return q.id;
}
